<template>
  <div class="upload">
    <p>{{ text }}</p>
    <QSpinner size="sm" color="grey-7" v-if="fileUploadLoading" />
    <div v-else>
      <div class="filecheckmark" v-if="file" style="background-color: var(--primary-color-background)">
        <i class="uiw-font-filecheckmark" style="color: var(--primary-color); margin-left: -10px" />
        <!-- <img src="/assets/icons/filecheckmark.svg" /> -->
      </div>
      <div class="file-upload" v-if="!file" style="background-color: var(--primary-color-background)">
        <i class="uiw-font-file-upload" style="color: var(--primary-color); margin-left: -10px" />
        <!-- <img src="/assets/icons/file-upload.svg" /> -->
      </div>
    </div>
    <div class="filename">{{ file ? file.fileName : '' }} &nbsp;</div>
    <a class="action" v-if="file" @click="onClickDelete">Delete</a>
    <span class="action" v-if="!file" @click="onClickUpload">Upload document</span>
    <div style="display: none">
      <QFile
        ref="file"
        :disable="disableFileInput"
        bg-color="grey-1"
        filled
        @input="onUpload"
        accept=".pdf"
        max-file-size="10240000"
        @rejected="onRejected"
      >
      </QFile>
    </div>
  </div>
</template>

<script>
/**
 * This component represents common UI for displaying the status in the progress list
 */
import { mapState, mapActions } from 'vuex';
import { QFile, QSpinner } from 'quasar';
import MutateGetSignedUrl from '../../graphql/mutations/MutateGetSignedUrl';
import MutateUploadWetSignature from '../../graphql/mutations/MutateUploadWetSignature';
import { GLOBAL_ERROR } from '../../components/GlobalError/GlobalError';

export default {
  name: 'DocumentUpload',
  components: { QFile, QSpinner },
  props: {
    text: String,
    wetSignatureObjName: String,
    applicationId: String,
    loadingDeleteProp: Boolean,
    isSubmitted: Boolean
  },
  watch: {
    loadingDeleteProp: function (newValue) {
      this.fileUploadLoading = newValue;
    }
  },
  computed: {
    ...mapState({
      scoreboard: (state) => state.vehicleApplication.vehicleApplication.scoreboard
    }),
    file() {
      if (
        this.scoreboard.wetSignature &&
        this.scoreboard.wetSignature[this.wetSignatureObjName] &&
        this.scoreboard.wetSignature[this.wetSignatureObjName].uploadFile &&
        this.scoreboard.wetSignature[this.wetSignatureObjName].uploadFile.uuid
      )
        return this.scoreboard.wetSignature[this.wetSignatureObjName].uploadFile;
      else return null;
    }
  },
  created() {},
  data: function () {
    return {
      fileUploadLoading: false,
      disableFileInput: false
    };
  },
  methods: {
    ...mapActions({
      updateWetSignatureState: 'vehicleApplication/updateWetSignatureState'
    }),
    onClickDelete() {
      if (this.isSubmitted) {
        alert('Sorry unable to delete!, File is already submitted!');
        return;
      }
      setTimeout(() => {
        this.$emit('onClickDelete', this.wetSignatureObjName);
      });
    },
    onClickUpload() {
      this.$refs.file.pickFiles();
    },
    onRejected: function (rejectedEntries) {
      alert('File size should be under 10MB.');
    },
    uploadFile: async function (file, signedUrl) {
      return await fetch(signedUrl, {
        method: 'PUT',
        body: file,
        headers: {
          'Content-Type': file.type
        }
      }).catch((error) => {
        this.error = true;
        if (error) {
          this.$euiNotifications.emit({
            notification: GLOBAL_ERROR
          });
        }
      });
    },
    onUpload: async function (file) {
      this.fileUploadLoading = true;
      const response = await this.$apollo
        .mutate({
          mutation: MutateGetSignedUrl,
          variables: {
            file: file,
            shouldUpload: false
          }
        })
        .catch((error) => {
          this.fileUploadLoading = false;
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });

      if (response && response.data && response.data && response.data.getSignedUrl) {
        const response2 = await this.uploadFile(file, response.data.getSignedUrl.signedUrl);

        if (response2 && response2.status == '200') {
          const fileObj = {
            fileName: response.data.getSignedUrl.fileName,
            uuid: response.data.getSignedUrl.uuid,
            mimeType: response.data.getSignedUrl.mimeType
          };
          await this.onCreateWetSignature(fileObj);
        }
      }

      this.fileUploadLoading = false;
    },
    onCreateWetSignature: async function (fileObj) {
      return await this.$apollo
        .mutate({
          mutation: MutateUploadWetSignature,
          variables: {
            applicationId: this.applicationId,
            wetSignatureObjName: this.wetSignatureObjName,
            uploadFileObj: fileObj
          }
        })
        .then((data) => {
          if (data && data.data && data.data.uploadWetSignature && data.data.uploadWetSignature.url) {
            let self = this;
            setTimeout(function () {
              self.updateWetSignatureState({
                uploadFile: fileObj,
                wetSignatureObjName: self.wetSignatureObjName
              });
            });
          }
        })
        .catch((error) => {
          this.fileUploadLoading = false;
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });
    }
  }
};
</script>

<style lang="sass" scoped>
.upload
  position: relative;
  border: 1px solid #E0E0E0;
  text-align: center;
  padding: 10px;
input[type=file]
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
.filecheckmark, .file-upload
  width: 40px;
  height: 40px;
  padding: 12px;
  border-radius: 50%;
  display: inline-block;
  margin-bottom: 7px;
.filecheckmark
  background: #EDF9E6;
.file-upload
  background: #E9F3FE;
.filename
  font-size: 10px;
  padding-bottom: 0;
  height: 20px;
.action
  cursor: pointer;
  font-size: 10px;
  color: var(--primary-color);
  text-decoration: underline;
</style>
